import { Facebook, Instagram, MapPin } from "lucide-react";
import { useLocation } from "react-router-dom";

export default function Footer() {
  const location = useLocation();
  const homePrefix = location.pathname === "/" ? "" : "/";
  const resolve = (href) => (href.startsWith("#") ? homePrefix + href : href);
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1A1A1A] py-20 text-[#F9F6F0]"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid gap-14 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <a href="#top" data-testid="footer-logo" className="inline-block">
              <img
                src="/assets/logo-full.png"
                alt="Spintastic City Laundry Services logo"
                className="w-52 rounded-[24px] shadow-[0_8px_32px_rgba(0,0,0,0.35)] transition-transform duration-500 hover:scale-[1.02]"
              />
            </a>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-[#F9F6F0]/50">
              Spintastic City Laundry Services — self-service, wash dry &amp;
              fold, and pickup &amp; delivery. Warm service, fresh results,
              right here in Bryans Road.
            </p>
            <div className="mt-8 flex items-center gap-3">
              <a
                href="https://www.facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-facebook-link"
                aria-label="Spintastic City on Facebook — page coming soon"
                className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-[#F9F6F0]/70 transition-[background-color,color,border-color] duration-300 hover:border-[#C85C40] hover:bg-[#C85C40] hover:text-white"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a
                href="https://www.instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram-link"
                aria-label="Spintastic City on Instagram — page coming soon"
                className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-[#F9F6F0]/70 transition-[background-color,color,border-color] duration-300 hover:border-[#C85C40] hover:bg-[#C85C40] hover:text-white"
              >
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>

          <div className="lg:col-span-3">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#F9F6F0]/40">
              Explore
            </p>
            <nav className="mt-6 flex flex-col gap-3" data-testid="footer-nav">
              {[
                { label: "Services", href: "#services", testid: "footer-services-link" },
                { label: "How It Works", href: "#order", testid: "footer-how-it-works-link" },
                { label: "Pricing", href: "#pricing", testid: "footer-pricing-link" },
                { label: "The App", href: "#app", testid: "footer-app-link" },
                { label: "Community", href: "/community", testid: "footer-community-link" },
                { label: "Contact", href: "#contact", testid: "footer-contact-link" },
              ].map((l) => (
                <a
                  key={l.href}
                  href={resolve(l.href)}
                  data-testid={l.testid}
                  className="w-fit text-sm text-[#F9F6F0]/70 transition-colors duration-300 hover:text-[#C85C40]"
                >
                  {l.label}
                </a>
              ))}
            </nav>
          </div>

          <div className="lg:col-span-4">
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#F9F6F0]/40">
              Find us
            </p>
            <div className="mt-6 flex items-start gap-3" data-testid="footer-address">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#C85C40]" />
              <p className="text-sm leading-relaxed text-[#F9F6F0]/70">
                6980 Indian Head Highway
                <br />
                Bryans Road, Maryland 20616
              </p>
            </div>
            <p className="mt-6 text-sm leading-relaxed text-[#F9F6F0]/50" data-testid="footer-hours">
              Mon, Tue, Thu–Sat · 8:00 AM – 8:00 PM
              <br />
              Sunday · 8:00 AM – 6:00 PM · Closed Wednesday
              <br />
              Last wash · 6:30 PM (Sun 4:30 PM)
            </p>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-4 border-t border-white/10 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-[#F9F6F0]/40">
            © 2026 Spintastic City Laundry Services. All rights reserved.
          </p>
          <p className="text-xs text-[#F9F6F0]/40">
            Online ordering powered by Cents &amp; Laundroworks.
          </p>
        </div>
      </div>
    </footer>
  );
}
